import React, { useState } from 'react';
import CashoutLabel from '../../common/CashoutLabel';
import MatchOdd from '../../common/MatchOdd';
import { classIf, getBetDescription, getConfiguration } from '../../data/utils';
import { ReactComponent as PinIcon } from '../../icons/pin.svg';
import { ReactComponent as FavoriteWh } from '../../icons/favoriteWh.svg';

import { FavoriteMarketsContext } from '../live-suite/LiveSuiteCompetition';

function LiveMatchBet(props) {
    const favoriteMarketsContext = React.useContext(FavoriteMarketsContext);
    const [collapsed, setCollapsed] = useState(false);
    const sportRef = props.matchData.sportRef;
    const betId = `${props.id}_${props.handicap}`;

    function toggleCollapsed() {
        setCollapsed(!collapsed);
    }

    function toggleFavorite(e) {
        e.stopPropagation();
        favoriteMarketsContext.toggleFavorite(sportRef, betId);
    }

    const oddsList = props.odds.map((odd, i) => {
        const id = `${props.uniqueId}_${odd.id}_${odd.desc.trim().length > 0 ? odd.desc : i}`;
        return (
            <MatchOdd key={id} {...odd} betData={odd.betData || props} matchData={props.matchData} />
        );
    });

    const conf = getConfiguration();
    const betDesc = props.isCompact ? props.desc : conf.iwh ? getBetDescription({ ...props }, false) : getBetDescription({ ...props }, false).toUpperCase();
    const oddsCount = props.odds.length;

    return (
        <div className="widget-elemento-live">
            <div className="quote-extra bordo-tondo">
                <div className="quote-extra-partita">
                    <div className={"titolo-giocate-extra toggle-nascondi-live d-flex pointer allinea-sx padding-orizzontale padding-verticale bordo-tondo" + classIf(collapsed, 'collapsed')} href={"#barra-extra-" + props.uniqueId} role="button" onClick={toggleCollapsed}>
                        <div className="w-100 d-flex items-center justify-content-between mr-1">
                            {betDesc}
                            <CashoutLabel bet={props} />
                        </div>
                        <div className="pin-toggle ml-auto mr-4" onClick={toggleFavorite}>
                            {conf.iwh ?
                                <FavoriteWh className={`${classIf(favoriteMarketsContext.isMarketFavorite(sportRef, betId), 'selected')} favoriteWh`}></FavoriteWh>

                                :
                                <PinIcon className={classIf(favoriteMarketsContext.isMarketFavorite(sportRef, betId), 'selected')}></PinIcon>
                            }

                        </div>
                    </div>
                    <div className={`collapse tabella-quote-extra d-grid bg-grigio-chiaro padding-verticale colonne-${oddsCount <= 3 ? oddsCount : 1}` + (collapsed ? '' : ' show')} id={"barra-extra-" + props.uniqueId}>
                        {oddsList}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LiveMatchBet;